import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import AutocompleteComponent from '../../../../components/filters/AutocompleteComponent'
import { GET_PHARMACIES } from '../../../../queries/pharmacies'
import { DailyMonitoringFiltersContext } from '../../../../context/DailyMonitoringFiltersContext'

export default function Pharmacies (): JSX.Element {
  const { filters, setFilters } = useContext(DailyMonitoringFiltersContext)
  const { loading, error, data } = useQuery(GET_PHARMACIES)

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.search) return <p>No data found</p>

  const pharmacies: Array<string> = []
  data.search.map((pharmacy: any) => {
    pharmacies.push(pharmacy.pharmacyName)
  })

  const onChange = (value: string[]) => {
    setFilters({
      pharmacies: value
    })
  }

  const typographLabel = 'Farmácia'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={pharmacies}
        defaultValues={filters.pharmacies}
        onChange={onChange}
      />
    </Fragment>
  )
}
